<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        title='新建联系人'
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='400'
      >
        <template v-slot:content>
           <v-card class="px-5" elevation="0">
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-text-field label="客户姓名"  hide-details='auto' filled rounded  dense :rules="required" v-model="form.name"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field label="手机号/固话" hide-details='auto' filled rounded  dense :rules="required" v-model="form.phoneNumber"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field label="微信号" hide-details='auto' filled rounded  dense :rules="required" v-model="form.wechatNumber"></v-text-field>
                </v-col>
              </v-row>
               <v-row>
                <v-col cols="12">
                  <v-text-field label="部门/职务" hide-details='auto' filled rounded  dense :rules="required" v-model="form.dept"></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-text-field label="邮箱地址" filled rounded  dense  v-model="form.emailAddress"></v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>
              <v-btn color="primary" rounded :loading="loading" @click='save'>
                保存
              </v-btn>
            </v-card-actions>

          </v-card>
        </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { save } from '@/api/customer/contacts.js'
  import { ResetObject } from '@/utils/stringUtil.js'

  export default {
    name: 'CustomerContactsEdit',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        form: {
          id: '',
          customerId: '',
          name: '',
          phoneNumber: '',
          wechatNumber: '',
          emailAddress: '',
          dept: '',
          hobby: ''
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.form.followTime = new Date(this.form.followTimeStr).getTime() / 1000
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      dialogChange (val) {
        this.item.show = val
        if (val && this.isEdit) {
          this.form.customerId = this.item.data.id
        } else {
          ResetObject(this.form)
        }
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
